exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_formExpander__2bL6B,.style_formNonExpander__1Gaxi{width:100%;box-shadow:none!important;border-radius:0!important;border-width:0!important;margin:0 0 -.0625rem;background-color:inherit!important}.style_formExpander__2bL6B>div:first-child,.style_formExpander__2bL6B>div:first-child>div:first-child,.style_formNonExpander__1Gaxi>div:first-child,.style_formNonExpander__1Gaxi>div:first-child>div:first-child{padding:0!important}.style_formExpander__2bL6B>div:first-child>div:first-child{cursor:pointer}.style_cardMedia__xmmZy{margin:0;padding:0}", ""]);

// exports
exports.locals = {
	"formExpander": "style_formExpander__2bL6B",
	"formNonExpander": "style_formNonExpander__1Gaxi",
	"cardMedia": "style_cardMedia__xmmZy"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/SimpleExpander/style.less
// module id = 1571
// module chunks = 8